import useSWR from "swr";

import getBuyerAPIDomain from "../getBuyerAPIDomain";
import fetchCurrentBids from "./fetchCurrentBids";
import { useAuth } from "@bca-auth0/bca-auth0-provider";
import { useSelector } from "react-redux";
import { GET_STATE } from "../redux/slices/appSlice";
import { StoreType } from "../StoreType";

export function useCurrentBids(currentBidsURL: string) {
  const {
    app: { isToUseAuthZero },
  }: StoreType = useSelector(GET_STATE);
  const { accessToken } = useAuth(!isToUseAuthZero);
  const buyerAPIDomain = getBuyerAPIDomain(isToUseAuthZero);
  var url = null;

  if (Boolean(currentBidsURL) && Boolean(buyerAPIDomain)) {
    url = new URL(`${buyerAPIDomain.href}/bid/current`);
    const queryStrings = new URL(currentBidsURL).searchParams.get("lotIds");
    url.searchParams.append("lotIds", queryStrings);
  }

  const getCurrentBidsURL = Boolean(url) ? url : null;

  const { data: currentBids, error: currentBidsError } = useSWR<any>(
    getCurrentBidsURL?.href && (accessToken || !isToUseAuthZero)
      ? [getCurrentBidsURL.href, accessToken, isToUseAuthZero]
      : null,
    fetchCurrentBids,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    }
  );

  return { currentBids, currentBidsError };
}
